var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.9 184.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #cc0202;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #c9c9c9;\n        stroke-miterlimit: 10;\n        stroke-width: .12px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.5,
    y: 80.4,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.54,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.6,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.57,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 136.64,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 136.64,
    y: 80.4,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.6,
    y: 80.4,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.57,
    y: 80.4,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.67,
    y: 80.4,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.67,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 136.64,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.61,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.57,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.54,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.5,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.71,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.71,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.67,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 136.64,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.61,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.57,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.57,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.64,
    y: 40.23,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.54,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.5,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 160.74,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 136.64,
    y: 96.47,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.6,
    y: 96.47,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.57,
    y: 96.47,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.67,
    y: 96.47,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.67,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 136.64,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.61,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.57,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.54,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.5,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.71,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.71,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.67,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 136.64,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.61,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.57,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.57,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.54,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.54,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.54,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.54,
    y: 136.64,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.54,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.54,
    y: 152.71,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.54,
    y: 160.74,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.57,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.57,
    y: 136.64,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.57,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.57,
    y: 152.71,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.57,
    y: 160.74,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.57,
    y: 168.78,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 136.64,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 152.71,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 160.74,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 168.78,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.57,
    y: 176.81,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.54,
    y: 168.78,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.5,
    y: 160.74,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.47,
    y: 152.71,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.44,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 176.81,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.33,
    y: 168.78,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.37,
    y: 160.74,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.4,
    y: 152.71,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 40.23,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 32.2,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 16.13,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 8.09,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.54,
    y: 8.09,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.5,
    y: 16.13,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.47,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 32.2,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 0.06,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.33,
    y: 8.09,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.37,
    y: 16.13,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.4,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.5,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.5,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.5,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.5,
    y: 136.64,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.5,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.47,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.47,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.47,
    y: 136.64,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.47,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.43,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.43,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.43,
    y: 136.64,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.5,
    y: 152.71,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.54,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.54,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.54,
    y: 40.23,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.54,
    y: 32.2,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.54,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.54,
    y: 16.13,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.5,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.5,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.5,
    y: 40.23,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.5,
    y: 32.2,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.47,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.47,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.47,
    y: 40.23,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.47,
    y: 32.2,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.43,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.43,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.43,
    y: 40.23,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.5,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 160.74,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.67,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.71,
    y: 96.47,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.74,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 168.78,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.74,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.71,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.67,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.64,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 128.6,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 168.77,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 176.81,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.57,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.57,
    y: 40.23,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.57,
    y: 32.2,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.57,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.57,
    y: 16.13,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.57,
    y: 8.09,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.57,
    y: 0.06,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.71,
    y: 80.4,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.74,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 168.78,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.74,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.71,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.67,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.64,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 128.6,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 168.77,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.67,
    y: 32.2,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.71,
    y: 32.2,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.67,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.71,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.74,
    y: 16.13,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.64,
    y: 136.64,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.67,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 144.67,
    y: 152.71,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.71,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.71,
    y: 152.71,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.74,
    y: 160.74,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.23,
    y: 136.64,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.2,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.2,
    y: 152.71,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 152.71,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.13,
    y: 160.74,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.23,
    y: 40.23,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.2,
    y: 32.2,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.2,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 32.2,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.13,
    y: 16.13,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 176.81,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.2,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 80.4,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.13,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.09,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.13,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.2,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.23,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.26,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.09,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.06,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 96.47,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.13,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.09,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.13,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.16,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.2,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.23,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.26,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.09,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.06,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.54,
    y: 80.4,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.47,
    y: 80.4,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.47,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.47,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.5,
    y: 96.47,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.54,
    y: 96.47,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.47,
    y: 96.47,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.43,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.47,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.47,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.37,
    y: 96.47,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.33,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.26,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.3,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.23,
    y: 88.43,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.23,
    y: 96.47,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.26,
    y: 96.47,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.3,
    y: 96.47,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.2,
    y: 96.47,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.2,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.23,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.26,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.3,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.37,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.16,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.16,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.2,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.23,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.26,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.3,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.33,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.37,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.13,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.23,
    y: 80.4,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.26,
    y: 80.4,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.3,
    y: 80.4,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.2,
    y: 80.4,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.2,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.23,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.26,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.3,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.37,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.16,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.16,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.2,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.23,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.26,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.3,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.33,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 40.23,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 32.2,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 16.13,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.37,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.37,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.37,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.37,
    y: 40.23,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.37,
    y: 32.2,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.4,
    y: 56.3,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.4,
    y: 48.26,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.4,
    y: 40.23,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.4,
    y: 32.2,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.37,
    y: 24.16,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 136.64,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 152.71,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.33,
    y: 160.74,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.37,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.37,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.37,
    y: 136.64,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.37,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.4,
    y: 120.57,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.4,
    y: 128.6,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.4,
    y: 136.64,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.4,
    y: 144.67,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.37,
    y: 152.71,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.13,
    y: 64.33,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.33,
    y: 96.47,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.4,
    y: 96.47,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.4,
    y: 104.5,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.4,
    y: 112.54,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.37,
    y: 80.4,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.33,
    y: 80.4,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.4,
    y: 80.4,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.4,
    y: 72.37,
    width: 8.03,
    height: 8.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.4,
    y: 64.33,
    width: 8.03,
    height: 8.03
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset4);
export default __webpack_public_path__ + "static/media/Asset4.1e5af5b4712b35415b00bbd3ada45a0b.svg";
export { ForwardRef as ReactComponent };